import { dashboardData } from "../utils/domain/operations.js";
import { state } from "../state/workspaceStore.js";
import { head } from "../components/common/PageHeader.jsx";
import { esc, money } from "../utils/format.js";
import { select, btn, errorSlot } from "../components/forms/FormControls.jsx";
import { periodFields } from "../components/dashboard/PeriodFields.jsx";
import { orderTable } from "../components/orders/OrderTable.jsx";
import { salesChart } from "../components/dashboard/CollectionSalesChart.jsx";
import { tableViews } from "../components/tables/RecordTable.jsx";
export function dashboard() {
  const a = dashboardData(state.db),
    p = state.periodDraft || state.db.dashboardPeriod;
  return (
    <>
      {head(
        "OVERVIEW",
        "Good day, " + state.db.profile.name.split(" ")[0] + ".",
        "Order dates · Asia/Kolkata · " + a.label,
        <details className={"calendar-control"}>
          <summary>
            {"\u25A6 "}
            {esc(a.label)}
            {" \xB7 Calendar"}
          </summary>
          <form id={"period-form"}>
            {select("Period", "mode", p.mode, [
              ["all", "All time"],
              ["day", "Specific date"],
              ["month", "Month and year"],
              ["year", "Entire year"],
              ["range", "Custom inclusive range"],
            ])}
            <div id={"period-inputs"}>{periodFields(p)}</div>
            <div className={"dialog-actions"}>
              <button className={"btn"} type={"submit"}>
                {"Apply"}
              </button>
              {btn("Reset", 'data-action="reset-period"', true)}
            </div>
            {errorSlot()}
          </form>
        </details>,
      )}
      {
        <>
          <div className={"metrics"}>
            <div className={"metric"}>
              <span>{"Products sold"}</span>
              <strong>{a.productsSold}</strong>
              <small>{"Distinct products \xB7 eligible sales"}</small>
            </div>
            <div className={"metric"}>
              <span>{"Orders"}</span>
              <strong>{a.orders.length}</strong>
              <small>{"Orders placed in selected period"}</small>
            </div>
            <div className={"metric"}>
              <span>{"Low-stock products"}</span>
              <strong>{a.lowStock}</strong>
              <small>{"Current stock \xB7 not historical"}</small>
            </div>
            <div className={"metric"}>
              <span>{"Revenue"}</span>
              <strong>{money(a.revenue)}</strong>
              <small>{"Successful payments, net of refunds"}</small>
            </div>
          </div>
          <div className={"grid-two"}>
            <section className={"card"}>
              <div className={"card-head"}>
                <h2>{"Recent orders"}</h2>
                <button className={"text-btn"} data-nav={"orders"}>
                  {"View all \u2192"}
                </button>
              </div>
              {a.orders.length ? (
                orderTable(
                  [...a.orders].sort((x, y) =>
                    String(y.date).localeCompare(String(x.date)),
                  ),
                  true,
                )
              ) : (
                <p className={"empty"}>{"No orders in this period."}</p>
              )}
            </section>
            <section className={"card"}>
              <h2>{"Collection Sales Analysis"}</h2>
              <p className={"notice chart-demo-note"}>
                {
                  "Demo chart \xB7 hard-coded percentages, not actual sales or approved launch activity."
                }
              </p>
              {salesChart(a)}
            </section>
          </div>
        </>
      }
    </>
  );
}
export default function DashboardPage({ recordId } = {}) {
  return tableViews(dashboard());
}
